export default __webpack_public_path__ + "static/media/RandomNotes2.cd97397a.jpg";